import { Chip, Stack } from "@mui/material";
import React from "react";
import { JobStatus } from "../../../Core/Api/Types/job-status";
import { GridValidRowModel } from "@mui/x-data-grid";
import { WorkflowStatus } from "../../../Core/Api/Types/workflow-status";
import { ObjectStatus } from "../../../Core/Api/Types/object-status";

export type TableCellJobStatusProps = {
  data: GridValidRowModel;
};

const TableCellJobStatus: React.FC<TableCellJobStatusProps> = (props) => {
  const value = props.data.value || props.data;
  let color: "default" | "primary" | "success" | "info" | "error" = "primary";
  let text = "";
  text = value as string;

  switch (value) {
    case JobStatus.READY:
    case JobStatus.CREATED:
    case WorkflowStatus.READY:
    case WorkflowStatus.CREATED:
    case ObjectStatus.New:
      color = "default";
      break;
    case JobStatus.RUNNING:
    case WorkflowStatus.RUNNING:
    case ObjectStatus.ParsedAndProbbed:
    case ObjectStatus.QualityCheckInProgress:
      color = "primary";
      break;

    case JobStatus.COMPLETED:
    case WorkflowStatus.COMPLETED:
    case ObjectStatus.Accepted:
      color = "success";
      break;
    case JobStatus.CANCELLED:
    case JobStatus.ABORTED:
    case WorkflowStatus.CANCELLED:
    case WorkflowStatus.ABORTED:
    case ObjectStatus.ToBeQCed:
    case ObjectStatus.ToBeDigitalized:
    case ObjectStatus.NeedCheckOrEditing:
    case ObjectStatus.WaitingForMEZZReference:
    case ObjectStatus.MissingMetadata:
      color = "info";
      break;
    case JobStatus.FAILED:
    case WorkflowStatus.FAILED:
    case ObjectStatus.Rejected:
    case ObjectStatus.RejectedAuto:
      color = "error";
      break;
  }

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Chip
        label={text}
        component="span"
        variant="outlined"
        color={color}
        size="small"
        sx={{ ml: 0.5, verticalAlign: "baseline" }}
      />
    </Stack>
  );
};

export default TableCellJobStatus;
